import { UserAgentPublicApp } from "@maersk-global/iam-al";

export const AL = new UserAgentPublicApp({
  client_id: "ida",
  authority: "https://accounts-stage.maersk.com/ocean-maeu", // your tenant
  realm: "mau",
  redirect_uri: window.location.origin + "/oauth2/callback",
  login_redirect_cb: (response, error) => {
    if (response) {
      window.location.href = "/"; // redirect home
    } else if (error) {
      console.error("Login error:", error);
    }
  },
});
